module.exports = __webpack_public_path__ + "img/more2.a17b0bfc.png";